module.exports = __webpack_public_path__ + "img/数据更新优势bg@2x.7856468e.png";